import { useCallback } from 'react';
import { scopedKey, resolveFacilityScopeId } from './bookingUtils';

export function useSlotConfiguration({ dispatch, state, activeFacilityId }) {
  const updateSlotConfiguration = useCallback(
    (configData) => {
      dispatch({ type: 'UPDATE_SLOT_CONFIGURATION', payload: configData });
    },
    [dispatch]
  );

  const addServiceConfiguration = useCallback(
    (serviceConfig) => {
      dispatch({ type: 'ADD_SERVICE_CONFIGURATION', payload: serviceConfig });
    },
    [dispatch]
  );

  const updateServiceConfiguration = useCallback(
    (index, config) => {
      dispatch({ type: 'UPDATE_SERVICE_CONFIGURATION', payload: { index, config } });
    },
    [dispatch]
  );

  const removeServiceConfiguration = useCallback(
    (index) => {
      dispatch({ type: 'REMOVE_SERVICE_CONFIGURATION', payload: index });
    },
    [dispatch]
  );

  const clearServiceConfig = useCallback(() => {
    try {
      const currentDateRange = state.slotConfiguration?.dateRange || null;
      dispatch({
        type: 'UPDATE_SLOT_CONFIGURATION',
        payload: { dateRange: currentDateRange, services: [] },
      });

      const configToSave = {
        dateRange: currentDateRange
          ? {
              startDate:
                currentDateRange.startDate instanceof Date
                  ? currentDateRange.startDate.toISOString()
                  : typeof currentDateRange.startDate === 'string'
                    ? currentDateRange.startDate
                    : null,
              endDate:
                currentDateRange.endDate instanceof Date
                  ? currentDateRange.endDate.toISOString()
                  : typeof currentDateRange.endDate === 'string'
                    ? currentDateRange.endDate
                    : null,
            }
          : null,
        services: [],
      };
      const slotKey = scopedKey('topgame_slotConfiguration', resolveFacilityScopeId(activeFacilityId));
      localStorage.setItem(slotKey, JSON.stringify(configToSave));
    } catch (error) {
      console.error('Error clearing service config:', error);
      alert('Error clearing service configuration. Please try again.');
    }
  }, [dispatch, state.slotConfiguration?.dateRange, activeFacilityId]);

  return {
    slotConfiguration: state.slotConfiguration,
    updateSlotConfiguration,
    addServiceConfiguration,
    updateServiceConfiguration,
    removeServiceConfiguration,
    clearServiceConfig,
  };
}
